/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconXieyi: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M749.098667 6.144H512a39.424 39.424 0 0 0-39.125333 39.765333v286.677334a39.850667 39.850667 0 0 0 20.992 34.261333c12.586667 6.698667 27.776 5.888 39.68-2.048l96.981333-65.066667L727.466667 364.8c11.989333 8.106667 27.434667 8.874667 40.149333 1.92a39.893333 39.893333 0 0 0 20.608-35.072V45.909333a39.466667 39.466667 0 0 0-39.082667-39.765333h-0.085333z m-11.733334 295.296l-85.248-66.56-0.469333-0.341333a38.570667 38.570667 0 0 0-42.666667 0.341333l-75.477333 64.853333V54.144h203.861333v247.296z"
        fill={getIconColor(color, 0, '#333333')}
      />
      <path
        d="M124.458667 0A39.424 39.424 0 0 0 85.333333 39.765333v944.469334c0 21.973333 17.493333 39.765333 39.125334 39.765333h775.082666a39.424 39.424 0 0 0 39.125334-39.765333V39.765333A39.424 39.424 0 0 0 899.541333 0H124.458667z m753.493333 64.469333v897.92H146.986667V64.469333h730.965333z"
        fill={getIconColor(color, 1, '#333333')}
      />
      <path
        d="M785.792 584.832a33.066667 33.066667 0 0 1-33.066667 33.024H271.274667a33.066667 33.066667 0 0 1 0-66.090667h481.450666c18.261333 0 33.066667 14.805333 33.066667 33.066667z m-312.917333 160.426667a34.389333 34.389333 0 0 1-34.389334 34.389333H272.64a34.389333 34.389333 0 0 1 0-68.778667h165.845333c18.986667 0 34.389333 15.36 34.389334 34.389334z"
        fill={getIconColor(color, 2, '#333333')}
      />
    </svg>
  );
};

IconXieyi.defaultProps = {
  size: 18,
};

export default IconXieyi;
